/* eslint-disable no-case-declarations */
import _ from 'lodash'

import * as Actions from './actions.js'
import pluralize from './pluralize.jsx'
const defaultState = {}

const getEntries = entries => {
  if (_.isArray(entries)) {
    return entries
  }
  if (entries.resourceType === 'Bundle') {
    return entries.entry.map(e => e.resource)
  }

  throw new Error(
    `Don't know how to get entries from response: ${JSON.stringify(entries)}`
  )
}

export default function reducer (state = defaultState, action) {
  const key =
    action && action.entryType ? pluralize.plural(action.entryType) : null
  const entrySet = (action && action.entrySet) || null

  switch (action.type) {
    case Actions.GET_ENTRIES:
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: true
        }
      }
    case Actions.GET_ENTRIES_SUCCESS:
      const entries = getEntries(action.entries).map(e =>
        action.mapFns.toForm(e))

      return {
        ...state,
        [key]: {
          ...state[key],
          entries,
          getNewEntries: false,
          loading: false,
          additionalData: action.additionalData
        }
      }
    case Actions.UPDATE_ENTRY_SUCCESS:
      const replaceEntry = e => (e.id === action.entry.id ? action.entry : e)

      return {
        ...state,
        [key]: {
          ...state[key],
          entries: state[key].entries.map(replaceEntry)
        }
      }
    case Actions.CREATE_ENTRY_SUCCESS:
      const newEntries = [ action.entry ].concat(state[key].entries)
      return {
        ...state,
        [key]: {
          ...state[key],
          entries: newEntries
        }
      }
    case Actions.SET_ENTRY_ERROR:
      return {
        ...state,
        [key]: {
          ...state[key],
          errors: {
            ...(state[key].errors || {}),
            [action.index]: action.error
          }
        }
      }
    case Actions.SHOW_NEW_ENTRY_FORM:
      if (entrySet) {
        const set = (state[key].set || {})[entrySet]
        return {
          ...state,
          [key]: {
            ...state[key],
            set: {
              ...state[key].set,
              [entrySet]: {
                ...set,
                newEntryFormVisible: true
              }
            }
          }
        }
      }
      return {
        ...state,
        [key]: {
          ...state[key],
          newEntryFormVisible: true
        }
      }

    case Actions.HIDE_NEW_ENTRY_FORM:
      if (entrySet) {
        const set = (state[key].set || {})[entrySet]
        return {
          ...state,
          [key]: {
            ...state[key],
            set: {
              ...state[key].set,
              [entrySet]: {
                ...set,
                newEntryFormVisible: false
              }
            }
          }
        }
      }
      return {
        ...state,
        [key]: {
          ...state[key],
          newEntryFormVisible: false
        }
      }

    case Actions.DELETE_REFERENCE:
      return {
        ...state,
        deleteReference: action.reference
      }
    case Actions.GET_NEW_ENTRIES:
      return {
        ...state,
        [key]: {
          ...state[key],
          getNewEntries: true
        }
      }
    case Actions.CHANGE_SORT_STATE:
      return {
        ...state,
        [key]: {
          ...state[key],
          sortOn: action.sortOn,
          sortDir: action.sortDir
        }
      }
    case Actions.RESET_SORT_STATE:
      return {
        ...state,
        [key]: {
          ...state[key],
          sortOn: 0,
          sortDir: 'desc'
        }
      }
    default:
      return state
  }
}
